import React from "react";
import { Link } from "react-router-dom";

export const CancelButton = props => <Link to={props.link} className="btn btn-faded">{props.title}</Link>
